import React from "react";
import { useSelector } from "react-redux";
import { selectCartCount } from "../../store/cartSlice";

const CartIcon = ({ onClick }) => {
  const count = useSelector(selectCartCount);
  return (
    <span onClick={onClick} className="position-relative me-1">
      <i className="bi bi-cart3 text-white cursor-pointer"></i>
      {count > 0 && (
        <span
          className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer"
          style={{ fontSize: "0.7rem" }}
        >
          {count}
        </span>
      )}
    </span>
  );
};

export default CartIcon;
